export default __webpack_public_path__ + "static/media/motimagri.53572772.jpg";